import { Heading } from "../data/balance";

export class Cell {
  constructor(readonly x: number, readonly y: number) {}

  step(heading: Heading): Cell {
    const [dx, dy] = headingOffset(heading);
    return new Cell(this.x + dx, this.y + dy);
  }

  equals(o: Cell): boolean { return this.x === o.x && this.y === o.y; }
  isAdjacent4(o: Cell): boolean { return manhattan(this, o) === 1; }
  toString(): string { return `(${this.x},${this.y})`; }
}

export function manhattan(a: Cell, b: Cell): number { return Math.abs(a.x - b.x) + Math.abs(a.y - b.y); }

/** Fixed iteration order for every neighbour scan (determinism). */
export const ALL_HEADINGS: readonly Heading[] = [Heading.North, Heading.East, Heading.South, Heading.West];

export function headingOffset(h: Heading): [number, number] {
  switch (h) {
    case Heading.North: return [0, 1];
    case Heading.East: return [1, 0];
    case Heading.South: return [0, -1];
    default: return [-1, 0];
  }
}

export function opposite(h: Heading): Heading { return ((h + 2) & 3) as Heading; }
export function rotateCw(h: Heading): Heading { return ((h + 1) & 3) as Heading; }
export function rotateCcw(h: Heading): Heading { return ((h + 3) & 3) as Heading; }

/** Heading of the unit step from a to b; a and b must be 4-adjacent. */
export function headingBetween(a: Cell, b: Cell): Heading {
  const dx = b.x - a.x, dy = b.y - a.y;
  if (dx === 0 && dy === 1) return Heading.North;
  if (dx === 1 && dy === 0) return Heading.East;
  if (dx === 0 && dy === -1) return Heading.South;
  if (dx === -1 && dy === 0) return Heading.West;
  throw new Error(`Cells are not 4-adjacent: ${a} ${b}`);
}
